<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="dedication">This book is dedicated to Lorna MacAlister and John Debenham-Taylor, formerly of the Special Operations Executive, and to all those who, as crew or passengers, flew The Hump.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?540294a1